/* section-cart.js — extracted from sections/cart.liquid */
  function initCartSection() {
    /* Page-level qty buttons AJAX */
    document.addEventListener('click', function (e) {
      let qtyBtn = e.target.closest('[data-qty-action][data-change-key]');
      if (!qtyBtn) return;
      let key = qtyBtn.dataset.changeKey;
      let container = qtyBtn.closest('.cart-item__qty');
      if (!container) return;
      let input = container.querySelector('.cart-item__qty-input');
      if (!input) return;
      let qty = parseInt(input.value, 10) || 1;
      qty = qtyBtn.dataset.qtyAction === 'plus' ? qty + 1 : Math.max(0, qty - 1);
      input.value = qty;
      clearTimeout(input._timer);
      input._timer = setTimeout(function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function () { window.location.reload(); }).catch(function () {});
      }, 400);
    });

    /* Remove item */
    document.addEventListener('click', function (e) {
      let removeBtn = e.target.closest('[data-remove-key].cart-page-item__remove');
      if (!removeBtn) return;
      let key = removeBtn.dataset.removeKey;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); }).catch(function () {});
    });

    /* Discount code redirect */
    let applyBtn = document.getElementById('cart-page-discount-apply');
    let discountInput = document.getElementById('cart-page-discount-input');
    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', function () {
        let code = discountInput.value.trim();
        if (code) window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      });
      discountInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') applyBtn.click();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSection);
  } else {
    initCartSection();
  }

  document.addEventListener('shopify:section:load', function(ev) {
    initCartSection();
  });
